import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.sort";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'custom-pagination',
  data: function data() {
    return {
      pageSize: 10,
      options: [{
        value: 10,
        label: '10条'
      }, {
        value: 20,
        label: '20条'
      }, {
        value: 30,
        label: '30条'
      }, {
        value: 40,
        label: '40条'
      }, {
        value: 50,
        label: '50条'
      }],
      countList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      selectPageValue: 1,
      disabled: false,
      showPage: true
    };
  },
  props: {
    maxPage: {
      default: 10
    }
  },
  watch: {
    maxPage: function maxPage() {
      var _this = this;

      // 最大页码变动时
      // 如果最大页码数>=10 则更新页码组为最大数为最大页码数的10个数的数组
      if (this.maxPage >= 10) {
        this.countList = new Array(10).fill('').map(function (v, i) {
          return _this.maxPage - i;
        }).sort(function (a, b) {
          return a - b;
        });
      } else {
        // 否则为十页以内 更新页码组
        this.countList = new Array(this.maxPage).fill('').map(function (v, i) {
          return i + 1;
        });
      }
    }
  },
  methods: {
    // 每页条数
    pageSizeChange: function pageSizeChange() {
      this.$emit('select', {
        current: this.selectPageValue,
        pageSize: this.pageSize
      });
    },
    // 点击页码
    selectPage: function selectPage(item) {
      if (this.disabled) return;
      this.selectPageValue = item;
      this.$emit('select', {
        current: this.selectPageValue,
        pageSize: this.pageSize
      });
    },
    // 上一页
    toPrev: function toPrev() {
      var _this2 = this;

      if (this.disabled) return; // 如果当前页为第一页，则不执行任何操作

      if (this.selectPageValue == 1) return;

      if (this.selectPageValue > 1) {
        this.selectPageValue--;
      } else {
        this.selectPageValue = 1;
      } // 如果当前页小于页码组的第一位，表明页码组需要向前递减更新（此时总页数一定超过十页，所以新的页码组保底10位数）


      if (this.selectPageValue < this.countList[0]) {
        // 创建一个以当前页为首的10位数的数组
        this.countList = new Array(10).fill('').map(function (v, i) {
          return _this2.selectPageValue + i;
        }).sort(function (a, b) {
          return a - b;
        });
      }

      this.$emit('select', {
        current: this.selectPageValue,
        pageSize: this.pageSize
      });
    },
    // 下一页
    toNext: function toNext() {
      if (this.disabled) return; // 如果当前页已经是当前页码组的最后一页，则需要先去请求下一页看看是否有数据，然后更新最大页码maxPage，进而根据最大页码变动来更新页码组

      if (this.selectPageValue == this.countList.slice(-1)[0]) {
        this.$emit('select', {
          maxPage: this.selectPageValue + 1,
          //传maxPage代表需要去请求下一页的数据，不传则直接请求当前页
          pageSize: this.pageSize
        });
      } else if (this.selectPageValue < this.countList.slice(-1)[0]) {
        // 否则就是当前页还在页码组范围内，直接+1
        this.selectPageValue++;
        this.$emit('select', {
          current: this.selectPageValue,
          pageSize: this.pageSize
        });
      }
    },
    // 重置页码
    resetPage: function resetPage() {
      this.selectPageValue = 1;
      this.$emit('select', {
        current: 1,
        pageSize: this.pageSize
      });
    }
  }
};